import { render, staticRenderFns } from "./plusClue.vue?vue&type=template&id=7b6f00f4&scoped=true&lang=html"
import script from "./plusClue.vue?vue&type=script&lang=js"
export * from "./plusClue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f00f4",
  null
  
)

export default component.exports